export default __webpack_public_path__ + "static/media/success.bac95a68.svg";